import { axios } from '@/utils/request'

const api = {
  store: '/stock/store'
}

const api2 = {
  storageAccessory: '/stock/storageAccessory'
}

const api3 = {
  accessory: '/stock/selectutils'
}

const api5 = {
  accessory: 'master/master'
}

const api4 = {
  province: '/basicdata/province',
  city: '/basicdata/city',
  area: '/basicdata/area',
  street: '/basicdata/street',
  management: '/enterprise/management',
}

const api6 = {
  system : '/system/user'
}

// 企业
export function getSelectTree (parameter) {
  return axios({
    url: api4.management + '/selectTree',
    method: 'get',
    params: parameter
  })
}

export function system (parameter) {
  return axios({
    url: api6.system + `/get/${parameter}`,
    method: 'get',

  })
}


export function queryMasterByPhone (parameter) {
  return axios({
    url: api5.accessory + '/queryMasterByPhone',
    method: 'get',
    params: parameter,

  })
}

export function selectAllProvince (parameter) {
  return axios({
    url: api4.province + '/selectAllProvince',
    method: 'post',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function cityCodeList (parameter) {
  console.log(parameter)
  return axios({
    url: api4.city + '/cityCodeList',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


export function provinceCodeList (parameter) {
  console.log(parameter)
  return axios({
    url: api4.city + '/provinceCodeList',
    method: 'get',
    params: parameter,

  })
}


export function selectCityName (parameter) {
  console.log(parameter)
  return axios({
    url: api4.city + '/selectCityName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 新增
export function addsave (parameter) {
  return axios({
    url: api.store + '/addsave',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 编辑
export function editstore (parameter) {
  return axios({
    url: api.store + '/editstore',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function area (parameter) {
  return axios({
    url: api.store + '/area',
    method: 'post',
    data: parameter
  })
}

export function organstorelist (parameter) {
  return axios({
    url: api.store + '/organstorelist',
    method: 'get',
    params: parameter
  })
}


export function getonestore (parameter) {
  return axios({
    url: api.store + '/getonestore',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


export function updatearea (parameter) {
  return axios({
    url: api.store + '/updatearea',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function forbidden (parameter) {
  return axios({
    url: api.store + '/forbidden',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}



export function workerstorelist (parameter) {
  return axios({
    url: api.store + '/workerstorelist',
    method: 'get',
    params: parameter
  })
}


export function getStorageAccessoryList (parameter) {
  return axios({
    url: api2.storageAccessory + '/accessorystoragelist',
    method: 'get',
        params: parameter
  })
}

export function selectenterprise (parameter) {
  return axios({
    url: api3.accessory + '/selectenterprise',
    method: 'get',
    params: parameter,

  })
}


export function selectuser (parameter) {
  return axios({
    url: api3.accessory + '/selectuser',
    method: 'get',
    params: parameter,

  })
}

export const storeExport = api.store + '/export'
